import React, { FunctionComponent, ReactNode } from 'react';
import styles from './ShellIcon.module.scss';

/**
 * Konturowe, jednolite ikony powłoki (siatka 16 px, kreska 1,5 px, kolor z `currentColor`),
 * wiernie z makiety fali D1. Ikony dekoracyjne: etykietę zawsze niesie sąsiedni tekst.
 */
const GLYPHS = {
  home: <path d="M2.5 7 8 2.5 13.5 7v6a.5.5 0 0 1-.5.5h-3v-4H6v4H3a.5.5 0 0 1-.5-.5z" />,
  folder: (
    <path d="M1.5 4.5a1 1 0 0 1 1-1h3.2l1.5 1.5h6.3a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H2.5a1 1 0 0 1-1-1z" />
  ),
  calendar: (
    <>
      <rect x="2" y="3" width="12" height="11" rx="1.5" />
      <path d="M2 6.5h12M5.5 1.5v3M10.5 1.5v3" />
    </>
  ),
  box: (
    <>
      <path d="M2 5 8 2l6 3v6l-6 3-6-3z" />
      <path d="m2 5 6 3 6-3M8 8v6" />
    </>
  ),
  bell: <path d="M4 11V7a4 4 0 0 1 8 0v4l1.2 1.5H2.8zM6.5 14a1.6 1.6 0 0 0 3 0" />,
  spaces: (
    <>
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="5" rx="1" />
      <path d="M11.5 9v5M9 11.5h5" />
    </>
  ),
  users: (
    <>
      <circle cx="6" cy="5.5" r="2.5" />
      <path d="M1.5 13.5a4.5 4.5 0 0 1 9 0M10.5 3.2a2.5 2.5 0 0 1 0 4.6M12 9.3a4.5 4.5 0 0 1 2.5 4.2" />
    </>
  ),
  shield: (
    <>
      <path d="M8 1.5 13.5 3.5v4c0 3.2-2.3 5.8-5.5 7-3.2-1.2-5.5-3.8-5.5-7v-4z" />
      <path d="m5.8 8 1.6 1.6L10.5 6.5" />
    </>
  ),
  layers: (
    <>
      <path d="M8 1.8 14.5 5 8 8.2 1.5 5z" />
      <path d="m1.5 8 6.5 3.2L14.5 8M1.5 11l6.5 3.2 6.5-3.2" />
    </>
  ),
  document: (
    <>
      <path d="M4 1.5h5.5L13 5v9a.5.5 0 0 1-.5.5h-8.5A.5.5 0 0 1 3.5 14V2a.5.5 0 0 1 .5-.5z" />
      <path d="M9.5 1.5V5H13M6 8.5h4M6 11h4" />
    </>
  ),
  chart: <path d="M2 14h12M4 11V7M8 11V3.5M12 11V8" />,
  truck: (
    <>
      <path d="M1.5 3.5h8v7h-8zM9.5 6h3l2 2.5v2h-5" />
      <circle cx="4.5" cy="12" r="1.3" />
      <circle cx="11.5" cy="12" r="1.3" />
    </>
  ),
  grid: (
    <>
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="5" rx="1" />
      <rect x="9" y="9" width="5" height="5" rx="1" />
    </>
  ),
  sliders: (
    <>
      <path d="M2.5 4.5h6M11.5 4.5h2M2.5 11.5h2M7.5 11.5h6" />
      <circle cx="10" cy="4.5" r="1.5" />
      <circle cx="6" cy="11.5" r="1.5" />
    </>
  ),
  gear: (
    <>
      <circle cx="8" cy="8" r="2.2" />
      <path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4" />
    </>
  ),
  lock: (
    <>
      <rect x="3" y="7" width="10" height="7" rx="1.2" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" />
    </>
  ),
  help: (
    <>
      <circle cx="8" cy="8" r="6.2" />
      <path d="M6.2 6.2a1.9 1.9 0 1 1 2.6 1.8c-.5.2-.8.6-.8 1.1v.4M8 11.6v.1" />
    </>
  ),
  menu: <path d="M2.5 4h11M2.5 8h11M2.5 12h11" />,
  close: <path d="m4 4 8 8M12 4l-8 8" />,
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="m10.5 10.5 3.5 3.5" />
    </>
  ),
  check: <path d="m3 8.5 3 3 7-7" />,
  plus: <path d="M8 3v10M3 8h10" />,
  chevronUpDown: <path d="M5 6 8 3l3 3M5 10l3 3 3-3" />,
  chevronDown: <path d="M4.5 6.5 8 10l3.5-3.5" />,
  card: (
    <>
      <rect x="1.5" y="3.5" width="13" height="9" rx="1.5" />
      <path d="M1.5 6.5h13M4 10h3" />
    </>
  ),
  logout: <path d="M6 2.5H3.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1H6M10.5 11 13.5 8l-3-3M13.5 8H6" />,
  alert: (
    <>
      <path d="M8 1.8 15 14H1z" />
      <path d="M8 6.2v3.4M8 11.6v.1" />
    </>
  ),
  info: (
    <>
      <circle cx="8" cy="8" r="6.2" />
      <path d="M8 7.2v4M8 4.8v.1" />
    </>
  ),
} satisfies Record<string, ReactNode>;

export type ShellIconName = keyof typeof GLYPHS;

interface ShellIconProps {
  name: ShellIconName;
  /** Rozmiar w px; domyślnie 16 (siatka ikony). */
  size?: 14 | 16;
}

const ShellIcon: FunctionComponent<ShellIconProps> = ({ name, size = 16 }) => (
  <svg
    className={size === 14 ? `${styles.icon} ${styles.small}` : styles.icon}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {GLYPHS[name]}
  </svg>
);

export default ShellIcon;
